'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.sa_group_create', {
        url: 'sa_group_create',
        template: '<sa-group-create></sa-group-create>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/sa_group/create/sa_group_create.routes.js